/* unplugin-vue-components disabled */import script from "./AppFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFeedback.vue?vue&type=script&setup=true&lang=js"

import "./AppFeedback.vue?vue&type=style&index=0&id=1325caf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1325caf0"]])

export default __exports__